<template>
    <section v-if="invoice.invoice_no" class="invoice-preview-wrapper">
        <div class="row invoice-preview">
            <div class="col-xl-9 col-md-8 col-12">
                <div class="card invoice-preview-card">
                    <div class="card-body invoice-padding pb-0">
                        <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                            <div class="d-flex flex-column align-self-end">
                                <p class="card-text mb-25">
                                    First Name: {{ invoice.user.firstname }}
                                </p>
                                <p class="card-text mb-25">
                                    Middle Name: {{ invoice.user.middle_name }}
                                </p>
                                <p class="card-text mb-0">
                                    Last Name: {{ invoice.user.lastname }}
                                </p>
                            </div>
                            <div class="mt-md-0 mt-2">
                                <h4 class="invoice-title">
                                    Invoice
                                    <span class="invoice-number"># {{ invoice.invoice_no }}</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <hr class="invoice-spacing" />
                    <div class="card-body invoice-padding pt-0">
                        <div class="row invoice-spacing">
                            <div class="col-xl-7 p-0">
                                <h6 class="mb-2">Bill To:</h6>
                                <h6 class="mb-25">{{ invoice.creditContact.creditor_name }}</h6>
                                <p class="card-text mb-25">{{ invoice.creditContact.address }}</p>
                                <p class="card-text mb-25">{{ invoice.creditContact.phone }}</p>
                            </div>
                            <div class="col-xl-5 p-0 mt-xl-0 mt-2">
                                <h6 class="mb-2">Payment Details:</h6>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td class="pr-1">Date Issued</td>
                                            <td><strong>{{ invoice.created_at }}</strong></td>
                                        </tr>
                                        <tr>
                                            <td class="pr-1">Payment Terms</td>
                                            <td><strong>Pay By Check</strong></td>
                                        </tr>
                                        <tr>
                                            <td class="pr-1">Due Date</td>
                                            <td><strong>DUE UPON RECEIPT</strong></td>
                                        </tr>
                                        <tr>
                                            <td class="pr-1">Balance Due:</td>
                                            <td>
                                                <span class="font-weight-bold">
                                                    <strong>$ {{ invoice.total }}</strong>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="py-1">Item</th>
                                    <th class="py-1">Violation</th>
                                    <th class="py-1">Cost</th>
                                    <th class="py-1">Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in invoice.items">
                                    <td class="py-1">
                                        {{ item.common_violation ? item.common_violation.common_violation_category.name : '' }}
                                    </td>
                                    <td class="py-1">
                                        {{ item.common_violation ? item.common_violation.definition : '' }}
                                    </td>
                                    <td class="py-1">
                                        {{ item.cost }}
                                    </td>
                                    <td class="py-1">
                                        {{ item.quantity }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-body invoice-padding pb-0">
                        <div class="row invoice-sales-total-wrapper">
                            <div class="col-md-6 order-md-1 order-2 mt-md-0 mt-3">
                            </div>
                            <div class="col-md-6 d-flex justify-content-end order-md-2 order-1">
                                <div class="invoice-total-wrapper">
                                    <div class="invoice-total-item">
                                        <p class="invoice-total-title">Total:</p>
                                        <p class="invoice-total-amount">$ {{ invoice.total }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="invoice-spacing" />
                    <div class="card-body invoice-padding pt-0">
                        <div class="row">
                            <div class="col-12">
                                <span class="font-weight-bold" readonly>Terms:</span>
                                <span>PAYMENT DUE UPON RECEIPT BY CHECK TO NAME AND ADDRESS NOTATED ABOVE. IF PAYMENT IS NOT REMITTED IN 20 DAYS, LATE FEES MAY INCUR AND A COMPLAINT CONCERNING UNFAIR AND DECEPTIVE COLLECTION PRACTICES MAY BE REFERRED TO THE BUREAU, THE BBB, AND/OR ATTORNEY GENERAL</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-4 col-12 invoice-actions mt-md-0 mt-2">
                <div class="card">
                    <div class="card-body">
                        <button
                            v-if="this.$route.params && this.$route.params.client"
                            class="btn btn-outline-secondary btn-block mb-75"
                            @click="invoiceStore.type = 4"
                        >
                            Edit
                        </button>
                        <router-link
                            v-else
                            :to="{ name: 'invoice-edit', params: { invoice: invoice.id } }"
                            class="btn btn-outline-secondary btn-block mb-75"
                        >
                            Edit
                        </router-link>
                        <button
                            v-if="this.$route.params && this.$route.params.client"
                            class="btn btn-outline-secondary btn-block mb-75"
                            @click="invoiceStore.type = 1"   
                        >
                            Back To Invocie
                        </button>
                        <router-link
                            v-else
                            :to="{ name: 'invoice-list' }"
                            class="btn btn-outline-secondary btn-block mb-75"
                        >
                            Back To Invocie
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { ref, reactive } from 'vue'
    import { useInvoiceStore } from '../../stores/InvoiceStore.js'
    export default {
        setup()
        {
            return {
                invoice : reactive({}),
                invoiceStore: useInvoiceStore(),
            }
        },
        mounted() {
            let params = {}, url = this.$route.href;
            if (this.$route.params && this.$route.params.client) {                
                const route = this.$router.resolve(
                    {
                        name: 'invoice-preview',
                        params: {
                            invoice: this.invoiceStore.invoice_id
                        }
                    }
                );
                url = route.href;
            }
            let $this = this;
            axios.get(
                url
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                Object.assign($this.invoice, response.data.data.invoice)
                return;
            }).catch(function(error) {
                setTimeout(() => {
                    toastr.error(error.response.data.response_msg, 'Error!');
                }, 2000)
            });
        }
    }
</script>
